import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { revokeAnalytics } from '../utils/analytics';
import SunMark from './SunMark';
import { useI18n } from '../i18n/I18nContext';
import './Footer.css';

function Footer({ showContactForm = true }) {
  const { lang, copy } = useI18n();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = copy.footer.mailSubject(formData.name);
    const body = `Name: ${formData.name}%0D%0AE-Mail: ${formData.email}%0D%0A%0D%0ANachricht:%0D%0A${formData.message}`;
    window.location.href = `mailto:mb@michaelabraun.de?subject=${encodeURIComponent(subject)}&body=${body}`;
  };

  const handleCookieSettings = () => {
    revokeAnalytics({ removeConsent: true, reload: true });
  };

  return (
    <footer className="michaela-footer">
      {showContactForm && (
        <div className="michaela-footer-contact-section">
          <div className="michaela-footer-contact-container">
            <div className="michaela-footer-contact-info">
              <h2 className="michaela-footer-contact-title mirror-ornament">{copy.footer.contactTitle}</h2>
              <p className="michaela-footer-contact-subtitle">
                {copy.footer.contactSubtitle}
              </p>
              
              <div className="michaela-footer-contact-details">
                <a href="tel:+491718208818" className="michaela-footer-contact-item">
                  <span>+49 (0)171 8208818</span>
                </a>
                <a href="mailto:mb@michaelabraun.de" className="michaela-footer-contact-item">
                  <span>mb@michaelabraun.de</span>
                </a>
                <div className="michaela-footer-contact-item">
                  <span>{lang === 'en' ? copy.services.address : 'Kirchenstraße 87 b, 81675 München'}</span>
                </div>
              </div>
            </div>

            <div className="michaela-footer-contact-form-wrapper">
              <form className="michaela-footer-contact-form" onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder={copy.footer.namePlaceholder}
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="michaela-footer-form-input"
                />
                <input
                  type="email"
                  name="email"
                  placeholder={copy.footer.emailPlaceholder}
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="michaela-footer-form-input"
                />
                <textarea
                  name="message"
                  placeholder={copy.footer.messagePlaceholder}
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="4"
                  className="michaela-footer-form-textarea"
                />
                <button type="submit" className="michaela-footer-form-button">
                  {copy.footer.send}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="michaela-footer-main">
        <div className="michaela-footer-container">
          <div className="michaela-footer-left">
            <div className="michaela-footer-brand">
              <img 
                src="/img/michaela_braun_2.png" 
                alt={copy.footer.logoAlt} 
                className="michaela-footer-logo"
              />
              <SunMark />
            </div>
            <h3 className="michaela-footer-heading">{copy.footer.aboutHeading}</h3>
            <p className="michaela-footer-text">
              {copy.footer.about}
            </p>
          </div>

          <div className="michaela-footer-right">
            <div className="michaela-footer-social">
              <a href="https://www.instagram.com/michaela.regine.braun" target="_blank" rel="noopener noreferrer" className="michaela-social-icon">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/in/prof-michaela-braun-81810121/" target="_blank" rel="noopener noreferrer" className="michaela-social-icon">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="michaela-footer-bottom">
        <p className="michaela-footer-copyright">
          Copyright © {new Date().getFullYear()} {copy.footer.copyrightName}
          <span>|</span>
          <Link to={lang === 'en' ? '/en/insights' : '/impulse'} className="michaela-footer-bottom-link">{copy.footer.insights}</Link>
          <span>|</span>
          <Link to={lang === 'en' ? '/en/speaking' : '/vortraege'} className="michaela-footer-bottom-link">{copy.footer.speaking}</Link>
          <span>|</span>
          <Link to={lang === 'en' ? '/en/privacy' : '/datenschutz'} className="michaela-footer-bottom-link">{copy.footer.privacy}</Link>
          <span>|</span>
          <Link to={lang === 'en' ? '/en/legal-notice' : '/impressum'} className="michaela-footer-bottom-link">{copy.footer.legal}</Link>
          <span>|</span>
          <button
            type="button"
            className="michaela-footer-bottom-link michaela-footer-bottom-button"
            onClick={handleCookieSettings}
          >
            {copy.footer.cookies}
          </button>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
